export default __webpack_public_path__ + "static/media/1801.e2c72dce.png";